const i18n = {
  'home_welcome': 'Bienvenue sur PGU BZH!',
  'home_title_mutations': 'Mutations',
  'label_select-language': 'Changer la langue',
  'select-language_br': 'Breton',
  'select-language_en': 'Anglais',
  'select-language_fr': 'Français',
  'action-apply-mutations': 'Executer',
  'label-with-mutations': 'avec mutations',
  'label-without-mutations': 'sans mutations',
  'ADJECTIVE_POSSESSIVE': 'ap - Adjectif possessif',
  'ADJECTIVE_QUALIFICATIVE': 'aq - Adjectif qualificatif',
  'ADVERB': 'av - Adverbe',
  'ARTICLE': 'ar - Article',
  'CARDINAL_BEFORE_SUBSTANTIF': 'ca - Cardinal devant un substantif',
  'COMPARATIVE': 'cp - Comparative',
  'CONJUNCTION_COORDINATING': 'cc - Conjonction de coordination',
  'CONJUNCTION_SUBORDINATE': 'cs - Conjonction de subordination',
  'ORDINAL': 'or - Ordinal',
  'OTHER': ':-) - non qualifié',
  'PARTICLE_VERBAL': 'pv - Particule verbale',
  'PREPOSITION': 'pn - Préposition',
  'PRONOUN': 'pr - Pronom',
  'PRONOUN_PERSONAL': 'pp - Pronom personnel',
  'PRONOUN_POSSESSIVE': 'ps - Pronom possessive',
  'NOUN': 'ns - Nom / Substantif',
  'NUMBER': 'nb - Nombre',
  'VERB': 'vb - Verbe',
  'MASCULINE': 'M',
  'FEMININE': 'F',
  'SINGULAR': 'S',
  'PLURAL': 'P',
  'PEOPLE': 'Personne',
  'is-reference': 'ref',
  'overview_soft': 'Adoucissantes',
  'overview_softIncomplete': 'Adoucissantes incomplètes',
  'overview_softIncompleteConditional': 'Adoucissantes incomplètes conditionnelles',
  'overview_hard': 'Durcissantes',
  'overview_incomplete': 'Incomplètes',
  'overview_mixed': 'Mixtes',
  'overview_spirante': 'Spirantes',
  'overview_subs_f_sg_m_pl': 'Après "ar", "ur", "an", "un"<br />Substantif, féminin singulier, masculins pluriels de personnes (!-où)',
  'overview_subs_m_sg_f_pl': 'Après "ar", "ur", "an", "un"<br />Substantif, masculin singulier, pluriels (féminins, masculins objets...)',
  'overview_adj_f_sg_m_pl': 'Adjectifs<br />féminin singulier, masculins pluriels de personnes (!-où)',
  'overview_mode-compact': 'mode compact',
  'modal_title_soft': 'Les adoucissantes',
  'modal_title_hard': 'Les durcissantes',
  'modal_title_mixed': 'Les mixtes',
  'modal_title_spirante': 'Les spirantes',
  'modal_title_incomplete': 'Les incomplètes',
  'modal_title_soft_incomplete': 'Les adoucissantes incomplètes',
  'modal_title_soft_conditional': 'Les adoucissantes conditionnelles',
  'mutations_in_songs_title': 'Mutations in songs',
};

export default i18n;
